import styled from 'styled-components'

export const StyledDeliveryDatesContainer = styled.div`
  margin: 0 0 12px 0;
  padding: 0 0 12px 0;
  line-height: 20px;
  border-bottom: 1px solid #D4D4D6;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    margin: 16px 0;
    padding: 0;
    border: none;
  }
`

export const StyledText = styled.span`
  color: #333;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 400;
`

export const StyledDate = styled.span`
  color: #333;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 600;
`

export const StyledButton = styled.button`
  color: #333;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  text-decoration-line: underline;
  border: none;
  padding: 0;
  margin: 0;
  background: none;
  cursor: pointer;
`
